import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import toast from 'react-hot-toast'
import App from './App'
import './styles/globals.css'
import { applyTheme } from './store/themeStore'
import type { Theme } from './store/themeStore'

// Apply saved theme before first paint to prevent flash
try {
  const stored = JSON.parse(localStorage.getItem('lumina-theme') ?? '{}') as { state?: { theme?: Theme } }
  applyTheme(stored?.state?.theme ?? 'system')
} catch {
  applyTheme('system')
}

// Register PWA service worker
import { registerSW } from 'virtual:pwa-register'

let swUpdate: (() => Promise<void>) | null = null

const updateSW = registerSW({
  onNeedRefresh() {
    swUpdate = () => updateSW(true)
    toast(
      (t) => (
        <div className="flex items-center gap-3">
          <span className="text-sm">New version available</span>
          <button
            onClick={() => { toast.dismiss(t.id); swUpdate?.() }}
            className="shrink-0 px-3 py-1 text-xs font-semibold bg-lumina-700 text-white rounded-lg hover:bg-lumina-800 transition-colors"
          >
            Update
          </button>
          <button
            onClick={() => toast.dismiss(t.id)}
            className="shrink-0 text-surface-400 hover:text-surface-600 text-xs"
          >
            Later
          </button>
        </div>
      ),
      {
        duration: Infinity,
        id: 'pwa-update',
        style: {
          background: 'white',
          color: '#1E293B',
          borderRadius: '12px',
          border: '1px solid #E2E8F0',
          boxShadow: '0 4px 16px rgba(0,0,0,0.10)',
          maxWidth: '380px',
          padding: '12px 16px',
        },
      },
    )
  },
  onOfflineReady() {
    toast.success('Ready to work offline', { id: 'pwa-offline', duration: 3000 })
  },
})

const root = document.getElementById('root')!
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
